import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { TranslocoCurrencyPipe } from '@jsverse/transloco-locale';
import { FiltreAccueilPeriode } from '../../../FiltreAccueilPeriode';
import { RetournerStatistiquesSuiviRegularisationsResultat } from '../../../RetournerStatistiquesSuiviRegularisationsResultat';
import { EFactVenteService } from '../../../val-efact-vente.service';
import { CarteDashboardComponent } from '../../carte-dashboard/carte-dashboard.component';

// Carte de suivi des régularisations
@Component({
	selector: 'val-carte-suivi-regularisations-vente',
	imports: [
		TranslocoModule,
		TranslocoCurrencyPipe,
		CarteDashboardComponent
	],
	templateUrl: './carte-suivi-regularisations.component.html',
	styleUrl: './carte-suivi-regularisations.component.scss'
})
export class CarteSuiviRegularisationsVenteComponent implements OnInit, OnChanges {

	constructor(private eFactVenteService: EFactVenteService, private router: Router) {
		this.filtrePeriode = FiltreAccueilPeriode.TrenteJours;
		this.chargementEnCours = false;
		this.estEnErreur = false;
		this.donnees = null;
	}

	// Période sélectionnée dans le filtre temporel
	@Input()
	public filtrePeriode: FiltreAccueilPeriode;

	// Indique si le chargement des données est en cours
	public chargementEnCours: boolean;

	// Indique si le dernier chargement s'est soldé par une erreur
	public estEnErreur: boolean;

	// Données de la carte
	public donnees: RetournerStatistiquesSuiviRegularisationsResultat | null;

	// Onglet « Mises en attente par l'acheteur » de la recherche des ventes (ONGLET.ID, base Search)
	//   Ses filtres portent les mêmes codes statut que le bloc de la carte : 206, 207, 208, UQ, CA (SU #118071).
	public readonly identifiantOngletMisesEnAttente: string = "65A9D0B3-4F27-4C6E-9B1A-8D2F3E4C5B6A";

	// Onglet « En erreur » de la recherche des ventes (ONGLET.ID, base Search)
	//   Ses filtres portent les mêmes codes statut que le bloc « Statuts bloquants à traiter » (SU #118071).
	public readonly identifiantOngletEnErreur: string = "8E4A1B2C-3D5F-4670-9A8B-C1D2E3F4A5B6";

	public async ngOnInit(): Promise<void> {
		await this.chargerDonnees();
	}

	public async ngOnChanges(changes: SimpleChanges): Promise<void> {
		if (changes['filtrePeriode'] && !changes['filtrePeriode'].firstChange)
			await this.chargerDonnees();
	}

	// Calcule la couleur de fond au survol (couleur du statut à 20% d'opacité)
	public CalculerCouleurFond(couleurCode: string | null | undefined): string {
		let couleurHex: string;
		let r: number;
		let g: number;
		let b: number;

		if (!couleurCode)
			return 'transparent';

		couleurHex = couleurCode.replace('#', '');
		r = parseInt(couleurHex.slice(0, 2), 16);
		g = parseInt(couleurHex.slice(2, 4), 16);
		b = parseInt(couleurHex.slice(4, 6), 16);

		return `rgba(${r}, ${g}, ${b}, 0.2)`;
	}

	// Navigue vers la grille des factures de vente, ouverte sur l'onglet du bloc cliqué
	//   Paramètres
	//     identifiantOnglet : Identifiant de l'onglet à ouvrir
	public NaviguerVersFacturesVente(identifiantOnglet: string): void {
		this.router.navigate(["/main", { outlets: { page: ['recherche-facture-vente', { onglet: identifiantOnglet }] } }], { skipLocationChange: true });
	}

	private async chargerDonnees(): Promise<void> {
		this.chargementEnCours = true;
		this.estEnErreur = false;
		this.donnees = null;

		try {
			const resultat = await this.eFactVenteService.RetournerStatistiquesSuiviRegularisations(this.filtrePeriode);
			if (resultat.status === 'success' && resultat.resultat)
				this.donnees = resultat.resultat;
			else
				this.estEnErreur = true;
		} catch {
			this.estEnErreur = true;
		} finally {
			this.chargementEnCours = false;
		}
	}
}
